import React from "react";
import GenericCard from "@ui-components/Card/GenericCard";
import { SkeletonBlock } from "@ui-components/Skeleton/GenericSkeleton";
import { TableSkeleton } from "@ui-components/Skeleton/TableSkeleton";
import ListPageLayout from "./ListPageLayout";
import ListPageToolbar from "./ListPageToolbar";

export interface ListPageLoadingProps {
  columns?: number;
  rows?: number;
}

/**
 * First load of a list view, drawn with the same layout, card and toolbar as the
 * loaded page (CTX-1614) so nothing shifts when the data arrives. Only for views
 * that render through `ListPageLayout`; `ListPageSkeleton` stays for the pages
 * that do not. The busy/test attributes ride on `ListPageLayout`'s root, not on a
 * wrapper: a wrapper would hide `[data-list-page]` from the container's `:has(>)`
 * rule (CTX-1615), the skeleton would not fill the window and the page would jump.
 */
export const ListPageLoading: React.FC<ListPageLoadingProps> = ({
  columns = 7,
  rows = 8,
}) => (
  <ListPageLayout data-testid="list-page-skeleton" aria-busy="true" aria-label="Loading">
    <div className="relative flex-1 min-h-0">
      <GenericCard
        isCollapsible={false}
        className="h-full flex flex-col"
        bodyContent={
          <div className="flex flex-col h-full min-h-0">
            <ListPageToolbar>
              <SkeletonBlock h={40} w="100%" className="max-w-full sm:max-w-[500px]" />
            </ListPageToolbar>
            <div className="flex-1 min-h-0 flex flex-col">
              <TableSkeleton columns={columns} rows={rows} />
            </div>
          </div>
        }
      />
    </div>
  </ListPageLayout>
);

export default ListPageLoading;
